import { render, staticRenderFns } from "./NewStudentInfo.vue?vue&type=template&id=b2216436&scoped=true"
import script from "./NewStudentInfo.vue?vue&type=script&lang=js"
export * from "./NewStudentInfo.vue?vue&type=script&lang=js"
import style0 from "./NewStudentInfo.vue?vue&type=style&index=0&id=b2216436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2216436",
  null
  
)

export default component.exports